<template>
  <div>
    <input type="text" name="" id="" placeholder="Enter email" v-model="ecommerceStore.email"><br>
    <input type="password" placeholder="Enter password" v-model="ecommerceStore.password">
    <button @click="ecommerceStore.handleLogin">Submit</button>
  </div>
</template>

<script>
import axios from 'axios';
import { useEcommerceStore } from '@/stores/Ecommerce';

export default {
data(){
  return{
    email:'',
    password:'',
    currentUser:'',
    ecommerceStore:''
  }
},
mounted(){
  

},
methods:{
  loginUser(){
    this.ecommerceStore = useEcommerceStore();
  }

}}
</script>

<style>

</style>